import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="mx-auto flex w-full max-w-7xl flex-col items-center justify-center px-4 py-24 text-center md:px-8">
      <span className="font-heading text-6xl font-black text-background-200 select-none md:text-8xl">
        404
      </span>
      <h1 className="mt-4 text-xl font-semibold text-foreground-950 md:text-2xl">
        抱歉，没有找到这个页面
      </h1>
      <p className="mt-2 max-w-md text-sm text-foreground-500">
        你访问的地址可能已经变更或不存在。可以返回首页，或前往分类页面继续浏览。
      </p>
      <p className="mt-1 font-mono text-xs text-foreground-400">{location.pathname}</p>
      <div className="mt-6 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-primary-600"
        >
          返回首页
        </Link>
        <Link
          to="/category/films"
          className="whitespace-nowrap rounded-md border border-background-200 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          浏览影视作品
        </Link>
      </div>
    </div>
  );
}